import FuncUtils from '@/common/utils/FuncUtils'

class ValidateUtils {
  /*
   * uri是否有效
   */
  static isExternal(path: string) {
    return /^(https?:|mailto:|tel:)/.test(path)
  }

  // 是否是数组
  static isArray(arg: any) {
    if (typeof Array.isArray === 'undefined') {
      return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
  }

  // 是否是数字
  static isNumber(content: string) {
    var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
    if (regPos.test(content) || regNeg.test(content)) {
      return true
    } else {
      return false
    }
  }
  // 是否是整数
  static isInteger(content: string) {
    var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
    if (regPos.test(content)) {
      return true
    } else {
      return false
    }
  }

  /**
   * 判断电话是否是手机号码
   * @param {*} phone
   */
  static isMobilePhone(phone: string) {
    if (phone === undefined || phone.length === 0) {
      return { result: false, hintMsg: '电话号码为空' }
    }
    if (phone.length !== 11) {
      return { result: false, hintMsg: '电话号码必须是11位数字' }
    }
    if (/^[1]([3-9])[0-9]{9}$/.test(phone) === false) {
      return { result: false, hintMsg: '不是有效的电话号码' }
    }
    return { result: true, hintMsg: '有效的电话号码' }
  }

  static isFixedPhone(fixedPhone: string) {
    if (/^(?:0[1-9][0-9]{1,2}-)?[2-8][0-9]{4,7}$/.test(fixedPhone) === false) {
      return { result: false, hintMsg: '不是有效的电话号码' }
    }
    return { result: true, hintMsg: '有效的电话号码' }
  }

  static isEmail(email: string) {
    // eslint-disable-next-line no-useless-escape
    if (/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(email) === false) {
      return { result: false, hintMsg: '不是有效的电子邮箱' }
    }
    return { result: true, hintMsg: '有效的电子邮箱' }
  }

  static isIdentity(identity: string) {
    if (/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(identity) === false) {
      return { result: false, hintMsg: '不是有效的身份证号码' }
    }
    return { result: true, hintMsg: '有效的身份证号码' }
  }

  static uploadFileAllType(file: any, maxSize: number = 5) {
    if (maxSize > 0) {
      const isLt2M = file.size / 1024 / 1024
      if (isLt2M > maxSize) {
        FuncUtils.hitMessageError('文件大小超过' + maxSize + 'M')
        return false
      }
    }

    if (file.type === 'application/pdf' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'application/vnd.ms-excel' ||
      file.type === 'application/msword' ||
      file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      return true
    } else {
      console.log(file.type)
    }
    FuncUtils.hitMessageError('不支持的文件格式')
    return false
  }

  static validateUploadArray(rule: any, value: any, callback: Function) {
    if (value.length === 0) {
      callback(new Error('请选择上传文件'))
    } else {
      callback()
    }
  }

  static validateMobile(rule: any, value: any, callback: Function) {
    const ret = ValidateUtils.isMobilePhone(value)
    if (!ret.result) {
      callback(new Error(ret.hintMsg))
    } else {
      callback()
    }
  }

  /**
   * 表单验证座机号码
   * @param rule
   * @param value
   * @param callback
   */
  static validateFixedPhone(rule: any, value: any, callback: Function) {
    const ret = ValidateUtils.isFixedPhone(value)
    if (!ret.result) {
      callback(new Error(ret.hintMsg))
    } else {
      callback()
    }
  }

  /**
   * 表单验证手机号码或座机号码
   * @param rule
   * @param value
   * @param callback
   */
  static validatePhone(rule: any, value: any, callback: Function) {
    const ret = ValidateUtils.isMobilePhone(value)
    if (!ret.result) {
      const ret2 = ValidateUtils.isFixedPhone(value)
      if (!ret2.result) {
        callback(new Error(ret2.hintMsg))
      } else {
        callback()
      }
    } else {
      callback()
    }
  }

  /**
   * 表单验证邮箱
   * @param rule
   * @param value
   * @param callback
   */
  static validateEmail(rule: any, value: any, callback: Function) {
    const ret = ValidateUtils.isEmail(value)
    if (!ret.result) {
      callback(new Error(ret.hintMsg))
    } else {
      callback()
    }
  }

  /**
   * 表单验证身份证号码
   * @param rule
   * @param value
   * @param callback
   */
  static validateIdentity(rule: any, value: any, callback: Function) {
    const ret = ValidateUtils.isIdentity(value)
    if (!ret.result) {
      callback(new Error(ret.hintMsg))
    } else {
      callback()
    }
  }

  static validateUploadFile(rule: any, value: any, callback: Function) {
    if (!value) {
      callback(new Error('请选择上传文件'))
    } else {
      callback()
    }
  }
}

export default ValidateUtils
